<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Invoice.Verification')"
    width="820px"
    :close-on-click-modal="false"
  >
    <div class="check-tip">
      <img :src="showNext ? warningIcon : falseIcon" style="margin-bottom: 15px;">
    </div>
    <el-table :data="rowData" :height="310">
      <el-table-column prop="invoiceNo" :label="$t('CargoMsg.Cargo_InvoiceNo')" width="180" show-overflow-tooltip />
      <el-table-column prop="jobNo" :label="$t('queryJob.businessNumber')" width="435" show-overflow-tooltip />
      <el-table-column prop="webPdfFile" :label="$t('Invoice.InvoiceDocument')" width="180" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <div v-if="row.webPdfFile"><img :src="acceptIcon"></div>
          <div v-else>{{ $t('Invoice.Missing') }}</div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button v-show="showNext" type="primary" @click="onNext">{{ $t('Message.GoOn') }}</el-button>
      <el-button type="danger" @click="innerVisible = false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import warningIcon from '@/assets/warning-x32.png'
import falseIcon from '@/assets/false-x32.png'
import acceptIcon from '@/assets/accept-x16.png'

export default {
  name: 'MergeInvoiceFileCheckingDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, default: () => [] },
    showNext: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      warningIcon,
      falseIcon,
      acceptIcon
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    onNext() {
      this.innerVisible = false
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    border: 1px solid #DCDFE6;
    th.el-table__cell,
    td.el-table__cell {
      border-right: 1px solid #DCDFE6;
    }
    th:last-child.el-table__cell,
    td:last-child.el-table__cell {
      border-right: none;
    }
    .el-table__header-wrapper {
      th.el-table__cell {
        background: #F2F2F2;
      }
    }
    .el-table__body-wrapper {
      &.is-scrolling-right {
        padding-right: 0;
      }
      padding-right: 22px;
    }
    tr {
      td:last-child {
        div.cell {
          padding-right: 23px;
        }
      }
    }
  }
}
.check-tip {
  margin: 5px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
